<template>
  <v-card v-if="datosEnvio" class="elevation-3">
    <v-container class="pb-0">
      <v-card-title class="pt-0 pl-1 mb-3 pr-0 d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <v-icon class="mr-2">mdi-information-outline</v-icon>
          <span class="text-h5 font-weight-medium">
            {{ mensajeDatosEnvio }}
          </span>
        </div>
        <v-btn
          icon
          class="to-right"
          variant="text"
          size="small"
          @click="cancelDatosEnvioDialog"
          id="v-btn-close-datos-envio"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-card class="mx-1 mb-4" variant="outlined">
        <v-card-text class="pa-0">
          <div class="json-container">
            <pre class="json-content">{{ formattedData }}</pre>
          </div>
        </v-card-text>
      </v-card>

    </v-container>
  </v-card>
</template>

<script>
import enums from "@/utils/enums/index";
import { mapActions } from "vuex";

export default {
  props: {
    logSolicitudId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      mensajeDatosEnvio: enums.messages.DATOS_ENVIO_MESSAGE,
      datosEnvio: null,
    };
  },
  computed: {
    formattedData() {
      if (!this.datosEnvio) return '';
      try {
        // Intentar parsear si es string JSON
        const parsed = typeof this.datosEnvio === 'string' 
          ? JSON.parse(this.datosEnvio) 
          : this.datosEnvio;
        return JSON.stringify(parsed, null, 2);
      } catch (error) {
        // Si no es JSON válido, retornar como texto plano
        return this.datosEnvio;
      }
    }
  },
  created() {
    this.setDatosEnvio();
  },
  methods: {
    ...mapActions({
      getDatosEnvioLog: "solicitud/getDatosEnvioLog",
      setAlert: "user/setAlert",
    }),
    async setDatosEnvio() {
      const logSolicitud = this.logSolicitudId;
      try {
        const response = await this.getDatosEnvioLog(logSolicitud);
        this.datosEnvio = response;
      } catch (error) {
        console.error(error);
      }
    },
    cancelDatosEnvioDialog() {
      this.$emit("anular-cancelado");
    },
  },
};
</script>

<style scoped>
.json-container {
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  max-height: 400px;
  overflow-y: auto;
}

.json-content {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 12px;
  line-height: 1.5;
  color: #212529;
  margin: 0;
  padding: 16px;
  background: transparent;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.json-content::-webkit-scrollbar {
  width: 8px;
}

.json-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.json-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.json-content::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Estilos para tema oscuro */
.v-theme--dark .json-container {
  background-color: #2d2d2d;
  border-color: #404040;
}

.v-theme--dark .json-content {
  color: #f8f9fa;
}

.v-theme--dark .json-content::-webkit-scrollbar-track {
  background: #404040;
}

.v-theme--dark .json-content::-webkit-scrollbar-thumb {
  background: #606060;
}

.v-theme--dark .json-content::-webkit-scrollbar-thumb:hover {
  background: #808080;
}
</style>
